import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, CircularProgress, Typography } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogConfirmRececao = ({ onClose, ...props }) => {
    const [loading, setLoading] = useState(false);
    const form = useFormik({
        initialValues: {
            primavera: ''
        },
        validationSchema: yup.object({
            primavera: yup.string().required('O campo é obrigatório')
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose(values);
        }
    });
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Confirmar receção</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <Typography>Para confirmar a receção da encomenda, por favor coloque o cód. do artigo criado no Primavera antes de continuar.</Typography>
            </Grid>
            <Grid lg={12} md={12} xs={12}>
              <TextField InputProps={{
            endAdornment: <React.Fragment>{loading ? <CircularProgress color='inherit' size={20}/> : null}</React.Fragment>
        }} label='Cód. Primavera *' name='primavera' defaultValue={form.values?.primavera} onChange={form.handleChange} onBlur={form.handleBlur} fullWidth error={form.touched.primavera && Boolean(form.errors.primavera)} helperText={form.touched.primavera && form.errors.primavera}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            form.handleSubmit();
        }} disabled={!form.isValid || !form.dirty || form.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogConfirmRececao;
